import { render, staticRenderFns } from "./crud-checkbox.vue?vue&type=template&id=33d676b2&"
import script from "./crud-checkbox.vue?vue&type=script&lang=js&"
export * from "./crud-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports